<template>
  <div class="container containerForm">
    <h2 style="text-align: center">إضافة عرض جديد</h2>
    <form @submit.prevent="addOffer">
      <div class="form-group">
        <label for="offer">النسبة المئوية لقيمة الخصم</label>
        <input type="number" class="form-control" id="offer" v-model="offerData.offer" />
      </div>
      <div class="form-group">
        <label>اختر المنتجات:</label>
        <div class="form-group product-selection">
          <div v-if="loadingProducts" class="loader">جار العرض...</div>
          <div v-for="product in productsArray" :key="product.id" class="toggle-token" :class="{
      'selected-token': isProductSelected(product.id),
    }" @click="toggleProduct(product.id)">
            <span class="token-text">{{ product.name }}</span>
          </div>
        </div>
      </div>
      <button type="submit" class="btn btn-primary">حفظ</button>
    </form>
  </div>
</template>

<script>
import Axios from "../../../Axios";

export default {
  data() {
    return {
      offerData: {
        offer: "",
        products: [],
      },
      productsArray: [],
      loadingProducts: false,
    };
  },
  methods: {
    toggleProduct(productId) {
      const index = this.offerData.products.indexOf(productId);
      if (index === -1) {
        this.offerData.products.push(productId);
      } else {
        this.offerData.products.splice(index, 1);
      }
    },

    isProductSelected(productId) {
      return this.offerData.products.includes(productId);
    },

    getAllProducts() {
      this.loadingProducts = true; // Set loading state to true
      Axios.get("/dashboard/products", { headers: { lang: "ar" } })
        .then((response) => {
          const totalPages = response.data.totalPages;
          const allProducts = response.data.products;

          // Fetch additional pages concurrently if needed
          const nextPagePromises = [];
          for (let page = 2; page <= totalPages; page++) {
            nextPagePromises.push(
              Axios.get(`/dashboard/products?page=${page}`, {
                headers: { lang: "ar" },
              })
            );
          }

          // Use Promise.all to wait for all additional pages to load
          return Promise.all(nextPagePromises)
            .then((nextPagesResponses) => {
              nextPagesResponses.forEach((pageResponse) => {
                allProducts.push(...pageResponse.data.products);
              });
              this.productsArray = allProducts;
              this.loadingProducts = false; // Set loading state to false when done
            })
            .catch((error) => {
              // console.error(error);
              this.loadingProducts = false; // Set loading state to false on error
            });
        })
        .catch((error) => {
          // console.error(error);
          this.loadingProducts = false; // Set loading state to false on error
        });
    },

    addOffer() {
      // Validate input fields
      if (!this.offerData.offer || this.offerData.products.length === 0) {
        this.$iziToast.error({
          timeout: 2000,
          message: "الرجاء إدخال قيمة الخصم واختيار منتج واحد على الأقل",
          position: "bottomRight",
        });
        return;
      }

      // Construct form data
      const formData = new FormData();
      const productsArr = [];
      formData.append('offer', this.offerData.offer);
      this.offerData.products.forEach(productId => {
        productsArr.push(productId);
      });
      formData.append('products', JSON.stringify(productsArr));

      // Send offer data to the server
      Axios.patch("/products/offers", formData, {
        headers: {
          'Content-Type': 'miltupart/form-data',
        }
      })
        .then((response) => {
          this.offerData = { offer: "", products: [] };
          this.$iziToast.success({
            timeout: 2000,
            message: "تم إضافة العرض بنجاح",
            position: "bottomRight",
          });
          this.$router.push("/admin/offers");
        })
        .catch((error) => {
          this.$iziToast.error({
            timeout: 3000,
            message: "فشل الإضافة، تأكد من اختيار منتج واحد على الأقل",
            position: "bottomRight",
          });
        });
    },

  },
  mounted() {
    this.getAllProducts();
  },
};
</script>

<style scoped>
.product-selection {
  margin-top: 10px;
  display: flex;
  flex-wrap: wrap;
}

.toggle-token {
  display: inline-block;
  background-color: #f3f1f0;
  color: rgb(116, 115, 115);
  border: 1px solid rgb(116, 115, 115);
  padding: 5px 10px;
  margin: 5px;
  border-radius: 10px;
  cursor: pointer;
  font-size: 20px;
}

.toggle-token:hover {
  background-color: rgb(159, 158, 158);
  color: #f3f1f0;
}

.selected-token {
  background-color: rgb(116, 115, 115);
  color: #f3f1f0;
  font-weight: bold;
}
</style>
